<template>
  <div class="bto-sb-widget bto-sb-widget-streaming-channel bto-sb-widget-betbuilder-list">
    <div class="bto-sb-widget-title">
      <h3>{{ t("BB.BetBuilder") }}</h3>
    </div>
    <div class="bto-sb-widget-content" v-if="Object.keys(sports).length > 0">
      <sports-list-component
        :sports="sports"
        :useRawSports="true"
        @changeSport="selectSport"
        :selected-sport="selectedSport"
        :scrollTriger="6" />
      <div class="bto-sb-streaming-content">
        <div data-bto-bb-fixture>
          <div
            class="bto-sb-streaming-event-item"
            v-for="(tournament, tidx) in getTournaments"
            :key="`${tidx}_${tournament.id}`">
            <div class="bto-sb-streaming-event-header">
              {{ tournament.name }}
            </div>
            <router-link
              class="bto-sb-streaming-event"
              :to="openMatch(match, selectedSport, tournament.name)"
              v-for="(match, midx) in tournament.matches"
              :key="`${midx}_${match.matchId}`">
              <div class="bto-sb-streaming-event-name">
                <span class="bto-sb-event-home">{{ match.homeTeam }}</span>
                <span class="bto-sb-event-away">{{ match.guestTeam }}</span>
              </div>
            </router-link>
          </div>
        </div>
        <empty-state
          v-if="getTournaments.length === 0"
          :message="t(loading ? 'Mobile.LoadingMore' : 'BB.NoEvents')"
          :hideShadow="loading"
          :icon-class="loading ? ICON_CLASS_LOADING : ICON_CLASS_EMPTY" />
      </div>
    </div>
    <div v-else>
      <div class="bto-sb-element">
        <empty-state
          :message="t(loading ? 'Mobile.LoadingMore' : 'BB.NoEvents')"
          :hideShadow="loading"
          :icon-class="loading ? ICON_CLASS_LOADING : ICON_CLASS_EMPTY" />
      </div>
    </div>
  </div>
</template>
<script>
  import store from '../../../store';
  import SportsListComponent from '../../common/match/sports-list-component';
  import BetBuilderFixtureRequestService from './betbuilder-fixture-request.service';
  import BetBuilderTournamentRequestService from './betbuilder-tournament-request.service';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'BetBuilderFixture',
    components: {
      SportsListComponent,
      EmptyState,
    },
    data() {
      return {
        sports: {},
        selectedSport: -1,
        message: '',
        loading: false,
        ICON_CLASS_LOADING: ICON_CLASS.LOADING,
        ICON_CLASS_EMPTY: ICON_CLASS.HIGHLIGHTS,
      };
    },
    computed: {
      getTournaments() {
        return (this.sports[this.selectedSport] && this.sports[this.selectedSport].fetchedTournamets) ? this.sports[this.selectedSport].tournaments : [];
      },
    },
    created() {
      const betBuilderFixtureRequestService = new BetBuilderFixtureRequestService();
      this.loading = true;
      betBuilderFixtureRequestService.execute((resp) => {
        this.loading = false;
        if (resp.data) {
          this.selectedSport = resp.data.s[0].id;
          this.sports = resp.data.s.reduce((sports, s) => {
            sports[s.id] = {
              id: s.id,
              name: s.n,
              class: s.c,
              tournamentIds: [],
              tournamentGroupIds: [],
              fetchedTournamets: false,
              tournaments: [],
            };

            const tournaments = sports[s.id].tournamentIds = s.i.flatMap(i => i.i);
            sports[s.id].tournaments = tournaments;
            sports[s.id].tournamentIds = tournaments.filter(t => t.t === 3).map(t => t.id);
            sports[s.id].tournamentGroupIds = tournaments.filter(t => t.t === 4).map(t => t.id);
            return sports;
          }, {});

          this.getTournametsForSport();
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    methods: {
      selectSport(sportId) {
        if (this.selectedSport === sportId) {
          return;
        }
        this.selectedSport = sportId;
        if (this.sports[sportId].fetchedTournamets) {
          return;
        }
        this.getTournametsForSport();
      },
      getTournametsForSport() {
        const selSport = this.sports[this.selectedSport];
        const betBuilderTournamentRequestService = new BetBuilderTournamentRequestService(selSport.tournamentIds, selSport.tournamentGroupIds);
        this.loading = true;
        betBuilderTournamentRequestService.execute(resp => {
          if (resp.data) {
            resp.data.forEach(sport => {
              const tournamentsMap = sport.t.reduce((acc, t) => {
                const matches = t.m.map(m => ({
                  matchId: m.mid,
                  sportCastFixtureId: m.scfi || undefined,
                  swishFixtureId: m.sm || undefined,
                  homeTeam: m.ht,
                  guestTeam: m.at
                }));

                acc[t.id] = {
                  name: t.nt,
                  id: t.id,
                  matches,
                };
                return acc;
              }, {});

              const tournaments = this.sports[sport.id].tournaments.filter(t => tournamentsMap[t.id]).map(t => tournamentsMap[t.id]);
              // UPDATE SPORT
              this.sports[sport.id] = {
                ...this.sports[sport.id],
                tournaments,
                fetchedTournamets: true,
              };
            });
          }
        }).finally(() => { this.loading = false; });
      },
      openMatch(match, sportId, tournamentName) {
        const rawSportName = store.getters.getSportName(sportId);
        const sportName = urlFriendlyParam(rawSportName);
        const eventName = urlFriendlyParam(`${match.homeTeam} vs ${match.guestTeam}`);
        const categoryName = urlFriendlyParam(tournamentName);
        return {
          name: 'seoGame',
          params: { sportName, categoryName, eventName, matchId: match.matchId },
          query: { scfi: match.sportCastFixtureId, sm: match.swishFixtureId },
        };
      },
    },
  };
</script>
<style scoped>
  div[data-bto-bb-fixture] {
    max-height: 296px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  div[data-bto-bb-fixture]::-webkit-scrollbar {
    display: none;
  }
</style>